import type { QuoteFile } from 'paintscout'
import { getAspectRatio } from '../../inlineEditable'

/**
 * The before/after comparison slider needs one shared box size for both images, but each image
 * carries its own independently-settable `presentationOptions.aspectRatio`. Prefers `leftImage`'s
 * ratio when set, falling back to `rightImage`'s, so the block only needs a caller to set the
 * option on one of the two images. Returns `null` when neither is set, so the caller can fall back
 * to its legacy raw-pixel-height sizing.
 */
export function getSliderAspectRatio(args: { leftImage?: QuoteFile; rightImage?: QuoteFile }): string | null {
  const { leftImage, rightImage } = args

  if (leftImage?.presentationOptions?.aspectRatio && leftImage.presentationOptions.aspectRatio !== 'unset') {
    return getAspectRatio({ file: leftImage, maxSquare: false })
  }

  if (rightImage?.presentationOptions?.aspectRatio && rightImage.presentationOptions.aspectRatio !== 'unset') {
    return getAspectRatio({ file: rightImage, maxSquare: false })
  }

  return null
}
